
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__female-profile",
  "use": "icon__female-profile-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon__female-profile\"><path d=\"M10 1.25c-4.822 0-8.75 3.928-8.75 8.75s3.928 8.75 8.75 8.75 8.75-3.928 8.75-8.75S14.822 1.25 10 1.25zm0 1.346A7.395 7.395 0 0 1 17.404 10c0 1.804-.642 3.45-1.704 4.733a6.09 6.09 0 0 0-3.428-3.613 3.354 3.354 0 0 0 1.093-2.466A3.375 3.375 0 0 0 10 5.288a3.375 3.375 0 0 0-3.365 3.366c0 .973.426 1.85 1.093 2.466a6.081 6.081 0 0 0-3.423 3.613A7.37 7.37 0 0 1 2.596 10 7.395 7.395 0 0 1 10 2.596zm0 4.039c1.125 0 2.02.894 2.02 2.019s-.895 2.02-2.02 2.02-2.02-.895-2.02-2.02.895-2.02 2.02-2.02zm0 5.384c2.287 0 4.165 1.625 4.601 3.781A7.373 7.373 0 0 1 10 17.404 7.35 7.35 0 0 1 5.404 15.8 4.683 4.683 0 0 1 10 12.02z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconFemaleProfileIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__female-profile" {...restProps} />
    })
  